export default "__VITE_ASSET__CFluNTGa__"